import { useEffect, useState } from "react";
import PageActions from "../../utils/page/library";

const useViewport = (appref, initState) => {
    const [viewport, setViewport] = useState(initState);

    const _viewportTransformCallback = (mediaqueryclass) => {
        setViewport(mediaqueryclass);
    };
    useEffect(() => {
        const componentInfo = {
            domnode: appref.current,
            callback: _viewportTransformCallback,
        };

        PageActions.registerMediaQueryObject(componentInfo);

        return () => {
            PageActions.unregisterMediaQueryObject(componentInfo);
        };
    }, []);

    return viewport;
};

export default useViewport;
